import React from "react";

export const Tick = () => (
  <svg viewBox="0 0 34.92 32.2">
    <title>yes</title>
    <path style={{fill: "none", stroke: "#96d5a4", strokeMiterlimit: 10, strokeWidth: "4px"}} d="m1.06 17.72 12.16 12.16L33.7.86"/>
  </svg>
)

export default Tick;
